import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store/store';
import { PlatformType } from '@/editor/shared/constants/available-platforms';
import { ISliderValuesPerPlatform } from '../reducers/selected-platforms.slice';

// Basic selectors
const selectActivePlatformsState = (state: RootState) => state.editorActivePlatformsReducer;

// Simple derived selectors
export const selectActivePlatforms = createSelector([selectActivePlatformsState], (state) => state.activePlatforms);

export const selectActivePlatformsBudgetSpreading = createSelector(
  [selectActivePlatformsState],
  (state) => state.activePlatformsBudgetSpreading
);

export const selectSlidersState = createSelector([selectActivePlatformsState], (state) => state.slidersState);

export const selectIsSliderActive = createSelector(
  [selectSlidersState, (_, platform: PlatformType) => platform],
  (sliders, platform) => {
    return sliders.find((el: ISliderValuesPerPlatform) => el.platform === platform)?.isActive;
  }
);

// Complex derived selectors
// export const selectPlatformBudget = createSelector(
//   [selectActivePlatformsBudgetSpreading, (_, platform: PlatformType) => platform],
//   (budgetSpreading, platform) => budgetSpreading[platform]
// );
//
// export const selectSelectedPlatform = createSelector([selectActivePlatformsState], (state) => state.selectedPlatform);
//
// export const selectActivePlatformsCount = createSelector([selectActivePlatforms], (platforms) => platforms.length);
//
// export const selectIsActivePlatform = createSelector(
//   [selectActivePlatforms, (_, platform: PlatformType) => platform],
//   (platforms, platform) => platforms.includes(platform)
// );
//
// export const selectPlatformSlider = createSelector(
//   [selectSlidersState, (_, platform: PlatformType) => platform],
//   (sliders, platform) => sliders.find((slider: ISliderValuesPerPlatform) => slider.platform === platform)
// );
//
// export const selectActivePlatformSliders = createSelector([selectSlidersState], (sliders) =>
//   sliders.filter((slider: ISliderValuesPerPlatform) => slider.isActive)
// );

// export const selectActivePlatformsWithBudget = createSelector(
//   [selectActivePlatforms, selectActivePlatformsBudgetSpreading],
//   (platforms, budgetSpreading) =>
//     platforms.map((platform: PlatformType) => ({
//       platform,
//       budget: budgetSpreading[platform],
//     }))
// );
//
// export const selectTotalBudgetAllocated = createSelector(
//   [selectActivePlatformsBudgetSpreading, selectActivePlatforms],
//   (budgetSpreading, activePlatforms) =>
//     activePlatforms.reduce((total: number, platform: PlatformType) => total + budgetSpreading[platform], 0)
// );
//
// export const selectTotalSliderValues = createSelector([selectSlidersState], (sliders) =>
//   sliders.reduce((total: number, slider: ISliderValuesPerPlatform) => total + slider.value, 0)
// );
//
// export const selectActiveSlidersTotalValue = createSelector([selectSlidersState], (sliders) =>
//   sliders
//     .filter((slider: ISliderValuesPerPlatform) => slider.isActive)
//     .reduce((total: number, slider: ISliderValuesPerPlatform) => total + slider.value, 0)
// );
